const DefaultData = {
    APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    TENANTID: 'trawtel',
    DEFAULTCOMPANYID: 'efd32bd2-6639-42ed-9b1a-7e262da1be07',
    DEFAULTBRANCHID: 'd6c4fbf0-f59b-4e38-a8f5-ea643ca4eaaf',
    DEFAULTCURRENCY: 'INR',
    WEBSITE: 'https://trawtel.com',
    DEFAULTCOMPANYEMAIL: 'support@trawtel.com',
    DEFAULTCOMPANYPHONENUMBER: '9177656344',
    DEFAULTCOMPANYGST: '36ANVPM2246A1Z0',
    DEFAULTCOMPANYNAME: 'TRAWTEL TOURISM',
    DEFAULTBRANDNAME: 'TRAWTEL',
    DEFAULTCOMPANYADDRESS: 'HYDERABAD, TELANGANA',
    FACEBOOKURL: 'https://www.facebook.com/trawtel',
    TWITTERURL: 'https://x.com/trawtel',
    INSTGRAMURL: 'https://www.instagram.com/trawtel',
    THEMECOLOR1: "#FBC027",
    THEMECOLOR2: "#1a1a1a",
    THEMECOLOR3: "#ffffff",
    THEMECOLOR4: "#000000",
    THEMECOLOR5:"#84804B",
    LANDINGPAGETITLE: "Empowering the Future of Travel Booking",
    LANDINGPAGESUBTITLE: "One stop solution for your travel business",
    B2BWEBSITE: "https://b2b.trawtel.com/",
    FOOTERCOPYRIGHTS: "2010 - 2025 TRAWTEL TOURISM.",
    FOOTERSUBTITLE: "We make your dream more beautiful & enjoyable with lots of happiness.",
    COMPANYTYPE: "CUSTOM",
    USERTYPE: "ADMIN",
    PLANTYPE:"CUSTOM"
};

export default DefaultData;